import { useMemo } from 'react';
import debounce from 'lodash/debounce';

export const useDebouncedAddressUpdate = setAddressToGeocode => {
  return useMemo(
    () =>
      debounce(value => {
        if (value && value.trim().length > 0) {
          setAddressToGeocode(value);
        } else {
          setAddressToGeocode('');
        }
      }, 500),
    [setAddressToGeocode],
  );
};

export default useDebouncedAddressUpdate;
